import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for webt the import according to your file structure

import authSlice from "./auth-slice";
import repositoriesSlice from "./repositories-slice";

// Persist config for auth
const authPersistConfig = {
  key: 'auth',
  storage,
};

// Persist config for repositories
const repositoriesPersistConfig = {
  key: 'repositories',
  storage,
};
const persistedAuthReducer = persistReducer(authPersistConfig, authSlice.reducer);
const persistedRepositoriesReducer = persistReducer(repositoriesPersistConfig, repositoriesSlice.reducer);


export const store = configureStore({
  reducer: {
    auth: persistedAuthReducer,
    repositories: persistedRepositoriesReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;


export const persistor = persistStore(store);
